import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete
} from "@react-google-maps/api";
import { toast } from "react-toastify";
import { toastOption } from "../../../../_metronic/_helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function GoogleMapsForm({ setFieldValue, values }) {
  // * DECLCARE HOOKS
  const [position, setPosition] = useState({
    lat: -6.17511,
    lng: 106.865036,
    zoom: 12
  });

  // * GOOGLE MAPS SETUP
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
    libraries: ["places"]
  });

  // * SET DEFAULT VALUE LNG LAT
  useEffect(() => {
    if (values.longitude && values.latitude) {
      setPosition(prev => ({
        ...prev,
        lat: +values.latitude,
        lng: +values.longitude,
        zoom: 18
      }));
    }
  }, [values]);

  // * GET AUTOCOMPLETE FROM GOOGLE MAP AND SET LAT & LNG
  const address = document.getElementById("input_address");
  // eslint-disable-next-line no-undef
  const autoComplete = new google.maps.places.Autocomplete(address);
  autoComplete.addListener("place_changed", () => {
    const place = autoComplete.getPlace();
    if (place.geometry) {
      setFieldValue("latitude", place.geometry.location.lat());
      setFieldValue("longitude", place.geometry.location.lng());
      setPosition({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        zoom: 18
      });
    }
  });

  return (
    <div className="form-group row">
      <div className="col">
        {!isLoaded ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="mb-4">
              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Cari Lokasi atau Klik pada peta untuk mengisi koordinat
                  </Tooltip>
                }
              >
                <label>
                  <h4>Pilih Lokasi</h4>
                </label>
              </OverlayTrigger>
              <input
                id="input_address"
                name="location"
                className="form-control"
                placeholder="Cari Lokasi"
              />
            </div>
            <GoogleMap
              zoom={position.zoom}
              center={{ lat: position.lat, lng: position.lng }}
              mapContainerStyle={{
                height: "calc(70vh)",
                width: "100%"
              }}
              onClick={e => {
                setPosition({
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng()
                });
                setFieldValue("latitude", e.latLng.lat());
                setFieldValue("longitude", e.latLng.lng());
              }}
            >
              <Marker position={{ lat: position.lat, lng: position.lng }} />
            </GoogleMap>
          </>
        )}
      </div>
    </div>
  );
}
